import { render } from "./PageUpdate.vue?vue&type=template&id=0ac633d2"
import script from "./PageUpdate.vue?vue&type=script&lang=js"
export * from "./PageUpdate.vue?vue&type=script&lang=js"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__